/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleDiscrepancyRequest } from '../../models/article-discrepancy-request';
import { KeyType } from '../../models/key-type';
import { VirtualArticleDiscrepancyResponse } from '../../models/virtual-article-discrepancy-response';

export interface AddBundleGroupVirtualArticleDiscrepancy$Params {
  organizationSiteKey: KeyType;
  groupKey: string;
  virtualArticleKey: string;
      body: ArticleDiscrepancyRequest
}

export function addBundleGroupVirtualArticleDiscrepancy(http: HttpClient, rootUrl: string, params: AddBundleGroupVirtualArticleDiscrepancy$Params, context?: HttpContext): Observable<StrictHttpResponse<VirtualArticleDiscrepancyResponse>> {
  const rb = new RequestBuilder(rootUrl, addBundleGroupVirtualArticleDiscrepancy.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('groupKey', params.groupKey, {});
    rb.path('virtualArticleKey', params.virtualArticleKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VirtualArticleDiscrepancyResponse>;
    })
  );
}

addBundleGroupVirtualArticleDiscrepancy.PATH = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/discrepancies';
